import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_CLIENT_URL;

export enum FieldSettingType {
  Field = 1,
  Section = 2,
}

// GET request: Fetch all field settings for a specific client
export function getClientFieldSettings(clientId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}SuperAdmin/clients/${clientId}/field-settings`, "GET");
}

// POST request: Save field settings for a specific client
export function saveClientFieldSettings(
  clientId: number,
  settings: any[]
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}SuperAdmin/clients/${clientId}/field-settings`, "POST", settings);
}
